import gql from 'graphql-tag';

/** Gets a randomly chosen demo activity to present on the front page of the app */
export const FrontPageActivityMapQuery = gql`
    query FrontPageActivityMapQuery($streamTypes: [String]!) {
        frontPageActivity {
            id
            activity {
                id
                lngLatStream {
                    id
                    data
                }
                mapBearing
                scalarStreams(streamTypes: $streamTypes) {
                    id
                    activity_id
                    type
                    friendlyName
                    data
                    units
                    isEmpty
                    resolution
                }
            }
        }
    }
`;

/** Get data to display the specified demonstration map */
export const DemoActivityMapQuery = gql`
    query DemoActivityMapQuery(
        $input: ActivityInput!
        $streamTypes: [String]!
    ) {
        demoActivity(input: $input) {
            id
            activity {
                id
                lngLatStream {
                    id
                    data
                }
                scalarStreams(streamTypes: $streamTypes) {
                    id
                    activity_id
                    type
                    friendlyName
                    data
                    units
                    isEmpty
                    resolution
                }
            }
        }
    }
`;

/** Get data to display the specified demonstration chart */
export const DemoActivityChartQuery = gql`
    query DemoActivityChartQuery(
        $input: ActivityInput!
        $streamTypes: [String]!
    ) {
        demoActivity(input: $input) {
            id
            activity {
                id
                scalarStreams(streamTypes: $streamTypes) {
                    id
                    activity_id
                    type
                    friendlyName
                    data
                    units
                    isEmpty
                    resolution
                }
            }
        }
    }
`;

/** Get data about a single activity */
export const DemoActivityQuery = gql`
    query DemoActivityQuery($input: ActivityInput!) {
        demoActivity(input: $input) {
            id
            activity {
                id
                name
                type
                location
                summaryPolyline
                timeSinceActivityInWords
                stats {
                    id
                    distance {
                        units
                        value
                    }
                    elapsedTime {
                        units
                        value
                    }
                    averageSpeed {
                        units
                        value
                    }
                    averagePace {
                        units
                        value
                    }
                }
            }
        }
    }
`;

/** Get data for the list of demo activities */
export const DemoActivityListQuery = gql`
    query DemoActivityListQuery($input: ActivityListInput) {
        demoActivityList(input: $input) {
            activities {
                id
                activity {
                    id
                    name
                    type
                    location
                    summaryPolyline
                    timeSinceActivityInWords
                    stats {
                        id
                        distance {
                            units
                            value
                        }
                        elapsedTime {
                            units
                            value
                        }
                        averageSpeed {
                            units
                            value
                        }
                        averagePace {
                            units
                            value
                        }
                    }
                }
            }
            pageInfo {
                page
                pageSize
            }
        }
    }
`;

/** Allows administrators to select activities to be displayed as examples */
export const AddDemoActivityMutation = gql`
    mutation AddDemoActivityMutation($id: String!) {
        addDemoActivity(id: $id)
    }
`;



// WEBPACK FOOTER //
// ./src/client/components/Strava/Demo/queries.ts